export const DocumentTypes: any = {
  payments_per_day: 101,
  payment_coupon: 102,
  mercosur_certificate: 103,
  policy: 104,
  certificate_of_coverage: 107,
};

export const PaymentsTypes: any = {
  automatic_debit: "Débito automático",
  credit_card: "Tarjeta de crédito",
  cupon: "Efectivo",
  collective_agreement: "Efectivo",
  home_banking: "Débito bancario",
};

export const CoverageStatus: any = {
  active: "Vigente",
  cancelled: "Cancelada",
  expired: "Vencida",
};

export const COLLECTION_UP_TO_DATE = "Cobertura: Activa";
export const COLLECTION_EXPIRED = "Cobertura: Suspendida";

// Los casos de uso para mostrar documentos son:

// - Si el estado es active, y la cobertura financiera es true, se deben mostrar todos los documentos.
// - Si el estado es active, y la cobertura financiera es false, se deben mostrar Póliza, Certificado de Cobertura, Certificado de Mercosur.
// - Si el estado es expired, se debe mostrar todos los documentos.
// - Si el estado es cancelled, se debe mostrar Póliza y Certificado de Cobertura.
//  Si la póliza tiene más de 4 vehículos, se debe mostrar Certificado de Mercosur

// COLOCAR ESTATUS EN DOCUMENTACION EL COVERAGE STATUS
